'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var lodash = require('lodash');
var jquery = require('jquery');
var moment = require('moment');
require('moment/locale/hr');
require('moment/locale/hu');
require('moment/locale/sl');
require('moment/locale/sk');
require('moment/locale/it');
require('moment/locale/en-gb');
var Decimal = require('decimal.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var jquery__default = /*#__PURE__*/_interopDefaultLegacy(jquery);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);
var Decimal__default = /*#__PURE__*/_interopDefaultLegacy(Decimal);

var name = "arm-common";
var version = "1.3.0";
var author = "Armundia Group";
var homepage = "http://www.armundia.com";
var license = "Armundia";
var main = "dist/main/index.js";
var files = [
	"dist"
];
var devDependencies = {
	"arm-gulp-builders": "2.0.0",
	"gulp-jsdoc3": "^3.0.0"
};
var dependencies = {
	"decimal.js": "^10.2.0",
	jquery: "^3.5.1",
	lodash: "^4.17.11",
	moment: "^2.24.0"
};
var scripts = {
	publishVersion: "gulp npm && npm publish",
	beta: "npm version prerelease --preid=beta && gulp npm && npm publish --tag beta",
	patch: "npm version patch && gulp npm && npm publish",
	minor: "npm version minor && gulp npm && npm publish",
	major: "npm version major && gulp npm && npm publish",
	"pre-release": "npm version prerelease && gulp npm && npm publish --tag=beta",
	"pre-patch": "npm version prepatch && gulp npm && npm publish --tag=beta",
	"pre-minor": "npm version preminor && gulp npm && npm publish --tag=beta",
	"pre-major": "npm version premajor && gulp npm && npm publish --tag=beta",
	watch: "gulp watch"
};
var publishConfig = {
	registry: "https://nexus.armundia.com/repository/npm-releases"
};
var pkg = {
	name: name,
	version: version,
	author: author,
	homepage: homepage,
	license: license,
	main: main,
	files: files,
	devDependencies: devDependencies,
	dependencies: dependencies,
	scripts: scripts,
	publishConfig: publishConfig
};

/**
 * Armundia NumberUtils
 * 
 */
var NumberUtils = /*#__PURE__*/function () {
  function NumberUtils() {}

  NumberUtils.convertMinutesInMilliseconds = function convertMinutesInMilliseconds(xMinutes) {
    var ret = null;

    if (xMinutes && typeof xMinutes === "number") {
      ret = xMinutes * 60 * 1000;
    }

    return ret;
  };

  return NumberUtils;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/** @typedef {Object<string, string>} i18nLabelsMap i18n labels map (LABEL_CODE: LABEL) */

/**
 * @callback i18nHandler callback to handle i18n labels
 * @param {i18nLabelsMap} currentLabels
 * @param {string} labelCode code to search in current labels
 * @param {string} labelDefault default label if code is not present
 */

/**
 * @typedef {object} Config arm-common configurations
 * @prop {i18nHandler} i18nHandler
 */

/** @type {Config} */
var config = {
  i18nHandler: function i18nHandler(currentLabels, labelCode, labelDefault) {
    return currentLabels && currentLabels[labelCode] || labelDefault;
  }
};

var authorizations = null;
var domini = null;
var i18nlabels = null;
var opzioni = null;
var locale = "it-IT";
moment__default["default"].locale(locale);
var store = null;
var PARAM_TOKENS_DELIMITER = "#";
/**
 * @param {String} sezione The SEZIONE from AP_OPZIONI
 * @param {Stirng} opzione The OPZIONE from AP_OPZIONI
 * @param {String} defaultValue If the opzione defined from the parameters is not found it is used this value
 * @returns {Ap_Opzioni} Opzione defined by the parameters
 */

function opt(sezione, opzione, defaultValue) {
  if (!opzioni) {
    if (defaultValue !== undefined) return defaultValue;
    return null;
  }

  var keyOpzione = sezione + '_' + opzione;
  var opzioneObj = opzioni[keyOpzione];
  if (opzioneObj) return opzioneObj.valore;else if (defaultValue) return defaultValue;else return null;
}
/**
 * @param {String} authid The AUTH_ID that a signed user in the application should have
 * @returns {boolean} 'True' if the user is authorized with the authorization passed
 */


function isAuth(authid) {
  if (!authorizations) {
    return false;
  }

  return authorizations[authid] !== null && authorizations[authid] !== undefined;
}
/**
 * @param {String} labelCode The CODE from AP_LANG
 * @param {String} labelDefault If the label defined from the parameters is not found it is used this value
 * @param  {...any} params E' per tutti quei testi che, una volta tradotti in base al linguaggio corrente 
 * dell'applicazione hanno bisogno di vedere valorizzati determinati valori come codiciStrumento, 
 * descrizione, etc. Es:
 * mex = "(#COD_STRUM#) #DES_SHORT# : Nota report conflitto interesse assente."
 * la stringa mex viene processata con i params che, uno alla volta, sostituiranno le stringhe #VALORE# con
 * i valori desiderati (notazione posizionale)
 * @returns {String} The translated value of the given label code into the session language
 */


function i18n(labelCode, labelDefault) {
  //modifica 25/10/2019, gestione lunghezza massima labelCode a 20
  var maxLength = 200; // vedi campo AP_LANG.CODE

  if (labelCode.length > maxLength) {
    labelCode = labelCode.substr(0, maxLength - 3) + '...';
  }

  var mex = config.i18nHandler(i18nlabels, labelCode, labelDefault);

  for (var _len = arguments.length, params = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    params[_key - 2] = arguments[_key];
  }

  if (params && mex) {
    // params = populateParametri(params);
    // let parametri = params.split(PARAM_TOKENS_DELIMITER);
    var parametri = params;

    for (var i = 0; i < parametri.length; i += 2) {
      var parametro = parametri[i];
      var valore = void 0;

      if (i < parametri.length - 1) {
        valore = parametri[i + 1];
      } else {
        valore = "[null]";
      }

      if (valore) {
        valore = String(valore);
      } else {
        valore = "[null]";
      }

      var currP = PARAM_TOKENS_DELIMITER + parametro + PARAM_TOKENS_DELIMITER;

      while (mex.indexOf(currP) > -1) {
        mex = mex.replace(currP, valore);
      }
    }
  }

  return mex;
}
/**
 * @param {String} codCampo The COD_CAMPO from AP_DOM
 * @returns {Array} All the domains from the given codCampo
 */


function domain(codCampo) {
  if (!domini) {
    return null;
  } //.valori[param.tipoParam].desDom


  if (!domini[codCampo]) {
    return null;
  }

  if (domini[codCampo].listValori) {
    return domini[codCampo].listValori;
  }

  console.log("function domanin " + codCampo); //per ottimizzare lo spazio occupato sullo store invece di restituire 2 liste per ogni dominio ne restituisco solo una
  //restituisco una Mappa di valori
  //Rutigliano 15/05/2019 converto la mappa in una lista 

  var items = domini[codCampo].valori;
  var keys = Object.getOwnPropertyNames(items);
  var risultato = [];

  for (var _iterator = _createForOfIteratorHelperLoose(keys), _step; !(_step = _iterator()).done;) {
    var key = _step.value;
    console.log("key [" + key + "]"); //ciclo le keys per recuperare gli ogetti della mappa ...

    var obj = items[key];
    var item = {};
    item.valCampo = obj.valCampo;
    item.desDom = obj.desDom;
    item.codCampo = obj.codCampo;
    item.info = obj.info;
    risultato.push(item);
  }

  console.log("restituisco la lista ....");
  return risultato;
}
/**
 * @param {String} codCampo The COD_CAMPO from AP_DOM
 * @param {String} valCampo The VAL_CAMPO from AP_DOM
 * @param {String} defaultvalue If the domain defined from the parameters is not found it is used this value
 * @returns {ApDom} The selected domain from the codCampo and valCampo passed
 */


function domainVal(codCampo, valCampo, defaultvalue) {
  if (!domini || !domini[codCampo]) {
    return defaultvalue ? {
      desDom: defaultvalue
    } : null;
  }

  var dom = domini[codCampo].valori[valCampo];

  if (dom) {
    return dom;
  }

  return {
    desDom: defaultvalue
  };
}
/**
 * 
 * @param {String} codCampo The COD_CAMPO from AP_DOM
 * @param {String} valCampo The VAL_CAMPO from AP_DOM
 * @param {String} nameInfo 
 */


function domainInfoVal(codCampo, valCampo, nameInfo) {
  var domainInfo = domainVal(codCampo, valCampo).info; //return this.valoreInfoSuDominio(domainInfo, nomeInfo);

  var valoreInfo = stringInfoVal(domainInfo, nameInfo);
  return valoreInfo;
}
/**
 * 
 * @param {String} domainInfo 
 */


function mapInfoVal(domainInfo) {
  console.log("mapInfoVal [nomeInfo] " + domainInfo);
  var mappaValori = {};

  if (domainInfo !== undefined && domainInfo !== null) {
    //split su info e prendo il valore del nome info passato
    //esempio valore: PROMO_CORPORATE:TRUE;PRIORITY:H;DAYS_TODEADLINE:5;RECIPIENT_TYPE:PER;
    var res = domainInfo.split(";");

    for (var i = 0; i < res.length; i++) {
      var currInfo = res[i]; //es.PROMO_CORPORATE:TRUE

      var currInfoSplit = currInfo.split(":");
      var currNomeInfo = currInfoSplit[0];
      var currValoreInfo = currInfoSplit[1];
      mappaValori[currNomeInfo] = currValoreInfo;
    }
  }

  return mappaValori;
}
/**
 * 
 * @param {String} domainInfo 
 * @param {String} nameInfo 
 */


function stringInfoVal(domainInfo, nameInfo) {
  console.log("stringInfoVal [nomeInfo] " + nameInfo);
  var valore = '';

  if (domainInfo !== undefined && domainInfo !== null) {
    //split su info e prendo il valore del nome info passato
    //esempio valore: PROMO_CORPORATE:TRUE;PRIORITY:H;DAYS_TODEADLINE:5;RECIPIENT_TYPE:PER;
    var res = domainInfo.split(";");

    for (var i = 0; i < res.length; i++) {
      var currInfo = res[i]; //es.PROMO_CORPORATE:TRUE

      var currInfoSplit = currInfo.split(":");
      var currNomeInfo = currInfoSplit[0];
      var currValoreInfo = currInfoSplit[1];

      if (nameInfo === currNomeInfo) {
        valore = currValoreInfo;
      }
    }
  }

  return valore;
}
/**
 * @param {String} newLocale example: 'IT-it'
 */


function setLocale(newLocale) {
  if (newLocale === void 0) {
    newLocale = 'it-IT';
  }

  locale = newLocale;
  moment__default["default"].locale(newLocale);
}
/**
 * @returns {locale} global
 */


function getLocale() {
  return locale;
}

function selectDomini(state) {
  return state.app.domini;
}

function selectAuth(state) {
  return state.app.authorizations;
}

function selectI18N(state) {
  return state.app.i18nlabels;
}

function selectOpzioni(state) {
  return state.app.opzioni;
}

function handleChange() {
  if (domini !== selectDomini(store.getState())) {
    console.log('DOMINI CHANGED');
    domini = selectDomini(store.getState());
  }

  if (authorizations !== selectAuth(store.getState())) {
    console.log('AUTORIZZAZIONI CHANGED');
    authorizations = selectAuth(store.getState());
  }

  if (i18nlabels !== selectI18N(store.getState())) {
    console.log('I18N LABELS CHANGED');
    i18nlabels = selectI18N(store.getState());
  }

  if (opzioni !== selectOpzioni(store.getState())) {
    console.log('OPZIONI CHANGED');
    opzioni = selectOpzioni(store.getState());
  }
}
/**
 * Function to initialize all the actions and stores connected with Redux
 * @param {*} auxStore The store of Redux to be considered
 * @param {*} auxActions All the actions that should be passed
 */


function armundiaInit(auxStore, auxActions) {
  console.log('INIT ARMUNDIA - ADD STORE LISTENER FOR DOMINI, AUTH, I18N');
  store = auxStore;
  store.subscribe(handleChange);
}

/**
 * @class
 * @classdesc Base class for all date formatings needed.<br/>
 * This class is used with a third party library wich is 'moment' so almost any output is processed with library.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.DateFormatter.[methodName]
 * @constructor
 * 
 */

function DateFormatter() {}
/**
 * Partendo da un qualsiasi tipo di data, vi viene applicata la formattazione
 * come da documentazione della libreria Moment
 * @param {*} date stringa date, timestamp, oggetto moment ed oggetto Date.
 * @param {*} format stringa formato moment https://momentjs.com/docs/#/parsing/string-format/
 * 
 * @returns La data formattata, oppure null.
 */


DateFormatter.prototype.formatDate = function (date, format) {
  var toDate = this.toDateNew(date);

  if (toDate !== null && format && format !== null && format !== "") {
    return moment__default["default"](toDate).format(format);
  }

  return toDate;
};
/**
 * Se il valore passato è una stringa che rappresenta un Date (formattata o non),
 * un timestamp o un oggetto Moment, ritorna l'oggetto javascript Date
 * @param {*} value valore rapprensentante la data
 * @returns se il valore è corretto, un oggetto Date, altrimenti null.
 */


DateFormatter.prototype.toDateNew = function (value) {
  if (value === undefined) {
    console.warn("[DateFormatter.toDate]: data non valorizzata");
    return null;
  }

  if (value === null) return null;
  if (value instanceof Date) return value;
  var date = new Date(value); //oggetto date convertito in stringa

  if (!isNaN(date)) return date;
  if (moment__default["default"].isMoment(value)) return value.toDate();

  if (typeof value === "string") {
    date = moment__default["default"](value, "x"); //verifico se è un timestamp

    if (date.isValid() && date.toDate().getTime() !== 0) return date.toDate();
  }

  console.warn("[DateFormatter.toDate]: data non corretta", {
    value: value
  });
  return null;
};
/**
 * Ritorna se le due date passate in ingresso sono uguali
 * indipendentemente dall'orario.
 * @param {*} date1 
 * @param {*} date2 
 * @returns moment(date1).isSame(date2);
 */


DateFormatter.prototype.equalsIngoreTime = function (date1, date2) {
  if (!date1 || !(date1 instanceof Date)) return 1;
  if (!date2 || !(date2 instanceof Date)) return 1;
  date1 = this.truncateTime(date1);
  date2 = this.truncateTime(date2);
  return moment__default["default"](date1).isSame(date2);
};
/**
 * Compara le date passate in ingresso non considerando il Time.
 * Restituisce -1/0/1 con lo stesso meccanismo della compare di Java.
 * @param {Date} date1 
 * @param {Date} date2 
 * @returns if (moment(date1).isSame(date2)) return 0; <br/>
 *      else if (moment(date1).isBefore(date2)) return -1; <br/>
 *      else if (moment(date1).isAfter(date2)) return 1; <br/>
 */


DateFormatter.prototype.compareIngoreTime = function (date1, date2) {
  if (!date1 || !(date1 instanceof Date)) return 1;
  if (!date2 || !(date2 instanceof Date)) return 1;
  date1 = this.truncateTime(date1);
  date2 = this.truncateTime(date2);
  if (moment__default["default"](date1).isSame(date2)) return 0;else if (moment__default["default"](date1).isBefore(date2)) return -1;else if (moment__default["default"](date1).isAfter(date2)) return 1;
};
/**
 * Prende in ingresso una data e ne restituisce una nuova
 * con ora, minuti e seondi azzerati.
 * 
 * @param date data da troncare
 * @returns date.setHours(0, 0, 0, 0)
 */


DateFormatter.prototype.truncateTime = function (date) {
  if (!date || !(date instanceof Date)) return null;
  return date.setHours(0, 0, 0, 0);
};
/**
 * 
 * @param {*} stringa 
 * @returns La stringa come Data
 */


DateFormatter.prototype.toDate = function (stringa) {
  // console.log('\t[toDate] armundia.js - TODATE ' + stringa);
  if (stringa instanceof Date) {
    //      console.log("\ttoDate invece di una stringa ho ricevuto una data! ");
    //    console.log('\ttoDate it-IT: ' + new Intl.DateTimeFormat('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(stringa));
    return stringa;
  }

  if (stringa === null) {
    //   console.log('\t[toDate] stringa null --> return ');
    return "-";
  }

  var parts = [];

  if (stringa.indexOf("-") < 0) {
    parts[0] = stringa.substring(0, 4);
    parts[1] = stringa.substring(4, 6);
    parts[2] = stringa.substring(6, 8); //console.log("data stringa " + stringa + " part0 " + parts[0]+ " part1 " + parts[1] + " part2 " + parts[2])
    //rrutigliano   //"20151130"

    parts[1] = parts[1] - 1;
  } else {
    //console.log('\t[toDate] stringa: ' + stringa);
    parts = stringa.split("-");
    parts[1] = parts[1] - 1;
  }

  if (parts.length !== 3) {
    throw 'Errore nel formato della data:' + stringa;
  }

  var myDate = null; //    console.log('\parts[2]: ' + parts[2]);
  //  console.log('\parts[1]: ' + parts[1]);
  //console.log('\parts[0]: ' + parts[0]);

  myDate = new Date(parts[0], parts[1], parts[2]); //let myDateFormat = new Intl.DateTimeFormat('it-IT', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(myDate);
  //console.log('\ttoDate risultato: ' + myDateFormat);

  return myDate;
};
/**
 * 
 * @param {String} aaaammgg format of the string should be 'YYYYMMDD' Y-year M-month D-day
 * @returns {Date} The date from the date passed in input with the given format
 */


DateFormatter.prototype.toDateFromInt = function (aaaammgg) {
  if (aaaammgg === null || aaaammgg === undefined || isNaN(aaaammgg)) return "";
  var parts = [];
  parts[0] = Math.floor(aaaammgg / 10000);
  parts[1] = Math.floor(aaaammgg % 10000 / 100) - 1;
  parts[2] = aaaammgg % 100;
  var myDate = null;
  myDate = new Date(parts[0], parts[1], parts[2]);
  return myDate;
};
/**
 * 
 * @param {String} aaaammgg format of the string should be 'YYYYMMDD' Y-year M-month D-day
 * @param {String} locale locale example: 'it-IT'
 * @returns {Date} The date from the date passed in input with the given format
 */


DateFormatter.prototype.formatIntDate = function (aaaammgg, locale) {
  var myDate = null;
  myDate = this.toDateFromInt(aaaammgg);
  if (!locale) locale = getLocale();
  var myDateFormat = new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  }).format(myDate);
  return myDateFormat;
};
/**
 * 
 * @param {*} value 
 * @param {*} defValue 
 * @param {*} locale 
 */


DateFormatter.prototype.dataFormatter = function (value, defValue, locale) {
  if (value === undefined || value === null || value === '') {
    return defValue ? defValue : "-";
  }

  if (!locale) locale = getLocale();
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric'
  }).format(value);
};
/**
 * 
 * @param {*} value 
 * @param {*} defValue 
 * @param {*} locale 
 */


DateFormatter.prototype.dataFormatterShort = function (value, defValue, locale) {
  if (value === undefined || value === null || value === '') {
    return defValue ? defValue : "-";
  }

  if (!locale) locale = getLocale();

  try {
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(value);
  } catch (error) {
    console.warn("Errore in formattazione data " + value, error);
    return value;
  }
};
/**
 * 
 * @param {*} data 
 * @param {*} defValue 
 */


DateFormatter.prototype.dateISO = function (data, defValue) {
  if (data === undefined || data === null) return defValue ? defValue : null;
  var myDateISO; // if (data instanceof Date) {
  //   myDateISO = data.toISOString();
  //} else {
  //nel caso di date nel formato numerico ... millisecondi
  //myDateISO = moment(data).toDate().toISOString();
  //}
  //Rutigliano 26/07/2017
  //devo escludere le informazioni sul time zone
  //console.log("UTC:" + moment.utc(data));
  //console.log("utcOffset: " + moment().utcOffset());
  //console.log("timeZonecOffset: " + moment().zone());

  myDateISO = moment__default["default"](data).format("YYYY-MM-DDTH:mm:ss.000") + "Z"; //console.log("[DateFormatter] dateISO: " + myDateISO);
  //myDateISO = moment(data).toISOString();
  //console.log("[DateFormatter] dateISO: " + myDateISO);

  return myDateISO;
};
/**
 * 
 * @param {*} data 
 * @param {*} defValue 
 */


DateFormatter.prototype.dateCheckShort = function (data, defValue) {
  if (data === undefined || data === null) return defValue ? defValue : null;
  var dt;
  dt = moment__default["default"](data).format("YYYY-MM-DD");
  return dt;
};
/**
 * 
 * @param {Date} date The date to wich add the months
 * @param {Number} months Months to add
 * @returns {Date} The date with the added months
 */


DateFormatter.prototype.addMonths = function (date, months) {
  //console.log("[armundia.js] addMonths " + months + " to date : " + this.dataFormatter(date));
  var d = moment__default["default"](date);
  d.add(months, 'months'); //console.log(" \t return addMonths " + this.dataFormatter(d.toDate()));

  return d.toDate();
};
/**
 * 
 * @param {*} date The date to wich add the days
 * @param {*} days Days to add
 * @returns {Date} The date with the added days
 */


DateFormatter.prototype.addDays = function (date, days) {
  //console.log("[armundia.js] days " + days + " to date : " + this.dataFormatter(date));
  var d = moment__default["default"](date);
  d.add(days, 'days'); //console.log(" \t return days " + this.dataFormatter(d.toDate()));

  return d.toDate();
};
/**
 * Ritorna la differenza tra due date in base al tipo passato in ingresso.
 * Se non si passa il tipo ritorna la differenza in giorni. (tipo = days)
 * 
 * @param {*} data1 
 * @param {*} data2 
 * @param {*} tipo sono validi i tipi gestiti da momentjs (days...)
 */


DateFormatter.prototype.dateDiff = function (data1, data2, tipo) {
  var a = moment__default["default"](data1);
  var b = moment__default["default"](data2);
  return a.diff(b, 'days');
};
/**
 * 
 * @param {*} data1 
 * @param {*} data2 
 * @param {*} tipo 
 */


DateFormatter.prototype.dateDiffInDays = function (data1, data2, tipo) {
  var a = moment__default["default"](data1);
  var b = moment__default["default"](data2);
  return b.diff(a, 'days') + 1;
};
/**
 * Restituisce il giorno lavorativo distante days da oggi, considerando come giorni festivi i sabati e le domeniche.
 * Esempio psOggi(-1) restituisce la data di ieri se oggi non è domenica o lunedì, altrimenti restituisce il venerdì precedente.
 * @param {*} days 
 */


DateFormatter.prototype.psOggi = function (days) {
  return this.psGiorno(new Date(), days);
};
/**
 * Restituisce il giorno lavorativo distante days da date, considerando come giorni festivi i sabati e le domeniche.
 * Esempio psGiorno(new Date(), -1) restituisce la data di ieri se oggi non è domenica o lunedì, altrimenti restituisce il venerdì precedente.
 * @param {*} date 
 * @param {*} days 
 */


DateFormatter.prototype.psGiorno = function (date, days) {
  var d = new Date(date);

  if (days !== 0) {
    for (var i = 0; i < Math.abs(days); i++) {
      d = this.addDays(d, days > 0 ? 1 : -1);

      while (d.getDay() === 0 || d.getDay() === 6) {
        d = this.addDays(d, days > 0 ? 1 : -1);
      }
    }
  }

  return d;
};
/**
 * Restituisce il primo lunedì precedente distante days da date.
 * Esempio psIniSett(new Date(), 0) restituisce la data odierna se oggi è lunedì, altrimenti restituisce il lunedì della settimana corrente.
 * @param {*} date 
 * @param {*} days 
 */


DateFormatter.prototype.psIniSett = function (date, days) {
  var d = new Date(date);
  d = this.addDays(d, days);
  d = this.addDays(d, -((d.getDay() - 1) % 7));
  return d;
};
/**
 * Restituisce il primo giorno del mese distante months da date.
 * Esempio psIniMese(new Date(), -1) restituisce il primo giorno del mese scorso.
 * @param {*} date 
 * @param {*} months 
 */


DateFormatter.prototype.psIniMese = function (date, months) {
  var d = new Date(date);
  d = this.addMonths(d, months);
  d.setDate(1);
  return d;
};
/**
 * Restituisce il primo giorno del trimestre distante months da date.
 * Esempio psIniTrim(new Date(), -1) restituisce il primo giorno del trimestre relativo allo scorso mese.
 * @param {*} date 
 * @param {*} months 
 */


DateFormatter.prototype.psIniTrim = function (date, months) {
  var d = new Date(date);
  var m = d.getMonth() + months;
  m = Math.ceil((m + 1) / 3);
  m = m * 3 - 3;
  d.setMonth(m);
  d.setDate(1);
  return d;
};
/**
 * Restituisce il primo giorno dell'anno distante years da date.
 * Esempio psIniAnno(new Date(), 1) restituisce il primo giorno del prossimo anno.
 * @param {*} date 
 * @param {*} years 
 */


DateFormatter.prototype.psIniAnno = function (date, years) {
  var d = new Date(date);
  d.setFullYear(d.getFullYear() + years);
  d.setMonth(0);
  d.setDate(1);
  return d;
};
/**
 * Restituisce l'ultimo giorno, si può scegliere se lavorativo o no, del mese distante months da date.
 * Esempio psFineMese(new Date(), -1, true) restituisce l'ultimo giorno lavorativo del mese scorso.
 * @param {*} date 
 * @param {*} months 
 * @param {*} working 
 */


DateFormatter.prototype.psFineMese = function (date, months, working) {
  var d = new Date(date);
  d = this.addMonths(d, months + 1);
  d.setDate(1);
  d = working ? this.psGiorno(d, -1) : this.addDays(d, -1);
  return d;
};
/**
 * Restituisce l'ultimo giorno, si può scegliere se lavorativo o no, del trimestre distante months da date.
 * Esempio psFineTrim(new Date(), -1, true) restituisce l'ultimo giorno lavorativo del trimestre relativo allo scorso mese.
 * @param {*} date 
 * @param {*} months 
 * @param {*} working 
 */


DateFormatter.prototype.psFineTrim = function (date, months, working) {
  var d = new Date(date);
  d = this.psIniTrim(d, months + 3);
  d = working ? this.psGiorno(d, -1) : this.addDays(d, -1);
  return d;
};
/**
 * Restituisce l'ultimo giorno, si può scegliere se lavorativo o no, dell'anno distante years da date.
 * Esempio psFineAnno(new Date(), 1, false) restituisce il 31 dicembre del prossimo anno.
 * @param {*} date 
 * @param {*} years 
 * @param {*} working 
 */


DateFormatter.prototype.psFineAnno = function (date, years, working) {
  var d = new Date(date);

  if (working) {
    d = this.psIniAnno(d, years + 1);
    d = this.psGiorno(d, -1);
  } else {
    d.setFullYear(d.getFullYear() + years);
    d.setMonth(11);
    d.setDate(31);
  }

  return d;
};
/**
 * 
 * @param {*} value 
 * @param {*} def 
 */


DateFormatter.prototype["short"] = function (value, def) {
  if (value === undefined || value === null || value === '') {
    return def || "-";
  }

  return moment__default["default"](value).locale(getLocale()).format("L");
};
/**
 * 
 * @param {*} value 
 */


DateFormatter.prototype.parseDate = function (value) {
  if (value === undefined || value === null) {
    return "-";
  }

  return moment__default["default"](value, 'DD/MM/YYYY').toDate();
};
/**
 * 
 * @param {*} value 
 * @param {*} format 
 */


DateFormatter.prototype.parseDateWithFormat = function (value, format) {
  if (!value || !format || typeof format !== 'string') {
    return "-";
  }

  return moment__default["default"](value, format).toDate();
};
/* parseDate(value, format) {
     if(value === undefined || value === null){
         return null || "-";
     }
     return moment(value, format).toDate()
 }*/

/**
 * 
 * @param {*} value 
 * @param {*} format 
 * @param {*} def 
 */


DateFormatter.prototype.parseTimestamp = function (value, format, def) {
  if (!value || format && typeof format !== 'string') {
    return def || "-";
  }

  if (!format) {
    format = "YYYY-MM-DD";
  }

  return moment__default["default"](value, format).toDate();
};
/**
 * 
 * @param {*} data 
 * @param {*} format 
 */


DateFormatter.prototype.formatDateFromMilisToString = function (data, format) {
  if (data === undefined || data === null || data === "") {
    return "-";
  }

  if (!format || typeof format !== 'string') {
    format = "YYYY-MM-DD";
  }

  var dataFormatata = moment__default["default"](parseInt(data)).format(format);
  return dataFormatata;
};

var exp$4 = new DateFormatter();

/**
 * @class
 * @classdesc All the methods in this class are needed to format the numbers.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.NumberFormatter.[methodName]
 */

function NumberFormatter() {}
/**
 * Set the locale for the NumberFormatter
 * @param {String} locale Locale ex: 'it-IT'
 */


NumberFormatter.prototype.persetDefaultLocale = function (locale) {};
/**
 * Get the actual Locale in use<br/>
 * @returns {locale} defaultLocale
 */


NumberFormatter.prototype.getDefaultLocale = function () {
  return getLocale();
};
/**
 * 
 * @param {*} n 
 * @param {*} width 
 * @param {*} z 
 */


NumberFormatter.prototype.pad = function (n, width, z) {
  z = z || '0';
  n = n + '';
  return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
};
/**
 * Format the number in percent format with 2 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.percent = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '2',
    maximumFractionDigits: '2'
  }).format(number) + '%';
};
/**
 * Format the number in percent format with 3 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.percent3Digit = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '3',
    maximumFractionDigits: '3'
  }).format(number) + '%';
};
/**
 * Format the number in percent format with 4 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.percent4Digit = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '4',
    maximumFractionDigits: '4'
  }).format(number) + '%';
};
/**
 * Format the number in percent format with 0 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.intPercent = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '0',
    maximumFractionDigits: '0'
  }).format(number) + '%';
};
/**
 * Format the number with 2 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || ""; //console.log('[NumberFormatter] format locale: ' + locale);

  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '2',
    maximumFractionDigits: '2'
  }).format(number);
};
/**
 * Format the number with 3 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format3Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 3, locale, defValue);
};
/**
 * Format the number with 4 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format4Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 4, locale, defValue);
};
/**
 * Format the number with 5 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format5Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 5, locale, defValue);
};
/**
 * Format the number with 6 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format6Digit = function (number, locale, defValue) {
  return this.formatWithDigits(number, 6, locale, defValue);
};
/**
 * Format the number with passed locale
 * @param {Number} number The number to be formatted
 * @param {Number} digits The number of decimal digits
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatWithDigits = function (number, digits, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";

  if (typeof digits !== 'string') {
    if (isNaN(digits)) return defValue || "";
  }

  if (!locale) locale = getLocale();
  var dgs = '' + digits;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: dgs,
    maximumFractionDigits: dgs
  }).format(number);
};
/**
 * Format the number with 0 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatInt = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '0',
    maximumFractionDigits: '0'
  }).format(number);
};
/*    
    format(number, locale, isMasked) {
        if (isMasked) {
            return "************";
        }
        locale = "it-CH";
        return new Intl.NumberFormat(locale, { minimumFractionDigits: '2', maximumFractionDigits: '2' }).format(number)
    }*/

/**
 * Format the number with 4 decimals
 * @param {Number} number The number to be formatted
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.format4FractionDigits = function (number, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '4',
    maximumFractionDigits: '4'
  }).format(number);
};
/**
 * Format the number with passed locale
 * @param {Number} number The number to be formatted
 * @param {Number} digits The number of decimal digits
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatDigits = function (number, digits, locale, defValue) {
  if (number === null || number === undefined || isNaN(number)) return defValue || "";
  if (!locale) locale = getLocale();
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: '' + digits,
    maximumFractionDigits: '' + digits
  }).format(number);
};
/**
 * Default formatter for the currencies. With 2 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatCurrency = function (number) {
  return this.formatDigits(number, 2, undefined, '');
};
/**
 * Default formatter for the prices. With 4 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatPrice = function (number) {
  return this.formatDigits(number, 4, undefined, '');
};
/**
 * Default formatter for quantity. With 3 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatQuantity = function (number) {
  return this.formatDigits(number, 3, undefined, '');
};
/**
 * Default formatter for percentages. With 2 decimal digits.
 * @param {Number} number The number to be formatted
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatPercentage = function (number) {
  return this.formatDigits(number, 2, undefined, '');
}; //JAVA PATTERN DEL TIPO #,##0.00000

/**
 * Format like a java pattern.<br/>
 * Java pattern example: #,##0.00000
 * @param {Number} number The number to be formatted
 * @param {String} javaPattern The pattern with witch it is intended to format
 * @param {String} locale If no locale is passed the defaultLocale is used
 * @param {String} defValue If the number passed is null or undefined this value is returned
 * @returns {String} The number formatted as a string
 */


NumberFormatter.prototype.formatFromJavaPattern = function (number, javaPattern, locale, defValue) {
  if (!number || !javaPattern || typeof javaPattern !== 'string' || javaPattern.length <= 0) return defValue || "";
  var digits = 0;
  var zeroValueIndex = javaPattern.indexOf("0.");

  if (zeroValueIndex !== -1) {
    zeroValueIndex = zeroValueIndex + 2;
    var temp = javaPattern.substring(zeroValueIndex, javaPattern.length);

    if (temp && temp.length > 0) {
      digits = temp.length;
    }
  }

  if (digits > 0) {
    return this.formatWithDigits(number, digits, locale, defValue);
  }

  return number;
};
/* formatFractionDigits(number, locale, isMasked) {
     if (isMasked) {
         return "************";
     }
     locale = "it-CH";
     return new Intl.NumberFormat(locale, { minimumFractionDigits: '4', maximumFractionDigits: '4' }).format(number)
 }*/

/**
 * Calculates the biggest size possible for the value passed. And converts it in the biggest possible size: B/KB/MB/GB
 * @param {Number} value The size value of the file to be calculated
 * @param {String} defValue If the value passed is null or undefined this value is returned
 * @returns {String} The biggest possible value in the biggest possible size
 */


NumberFormatter.prototype.byteSize = function (value, defValue) {
  if (value === null || value === undefined || isNaN(value)) return defValue || "";
  var size; // KB 1024 
  // MB 1024 * 1024 = 1048576
  // GB 1024 * 1024 * 1024 =   1073741824

  size = value / 1073741824;

  if (size > 1) {
    return this.format(size) + " GB";
  }

  size = value / 1048576;

  if (size > 1) {
    return this.format(size) + " MB";
  }

  size = value / 1024;

  if (size > 1) {
    return this.format(size) + " KB";
  }

  return value + " B";
};

var NumberFormatter$1 = new NumberFormatter();

/**
 * @class
 * @classdesc UI Utils <br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.UiUtils.[methodName] <br/>
 * @constructor
 */

function UiUtils() {}
/**
 * 
 * @param {*} col 
 * @param {*} amt 
 */


UiUtils.prototype.LightenDarkenColor = function (col, amt) {
  var usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  var num = parseInt(col, 16);
  var r = (num >> 16) + amt;
  if (r > 255) r = 255;else if (r < 0) r = 0;
  var b = (num >> 8 & 0x00FF) + amt;
  if (b > 255) b = 255;else if (b < 0) b = 0;
  var g = (num & 0x0000FF) + amt;
  if (g > 255) g = 255;else if (g < 0) g = 0;
  return (usePound ? "#" : "") + (g | b << 8 | r << 16).toString(16);
};
/**
 * 
 * @param {*} text 
 */


UiUtils.prototype.isNil = function (text) {
  return text === null || text === undefined || text === "";
};
/**
 * 
 * @param {*} text 
 * @param {*} deftxt 
 */


UiUtils.prototype.text = function (text, deftxt) {
  if (UiUtils.isNil(text)) return deftxt || "";
  return text;
};
/**
 * 
 * @param {*} icon 
 */


UiUtils.prototype.icon = function (icon) {
  if (!icon) return null;
  if (icon.indexOf("fa ") < 0 && icon.indexOf(" fa ") < 0) icon = "fa " + icon;
  return /*#__PURE__*/React.createElement("i", {
    className: icon,
    "aria-hidden": true
  });
};
/**
 * 
 * @param {*} text 
 * @param {*} deftxt 
 */


UiUtils.prototype.yesno = function (text, deftxt) {
  if (text === undefined || text === null) return deftxt;
  var b;

  if (text instanceof Boolean) {
    b = text;
  } else {
    text = "" + text;
    text = text.toLowerCase();
    b = text === 'true' || text === 'yes' || text === 'ok' || text === '1' || text === '-1';
  }

  return b ? 'yes' : 'no';
};
/**
 * 
 */


UiUtils.prototype.texts = function () {
  if (arguments.length < 2) return "";
  var deftxt = arguments[0];
  var separator = arguments[1];
  var res = "";
  var sep = "";
  var some = false;

  for (var i = 2; i < arguments.length; i++) {
    var r = arguments[i];
    if (!r) continue;
    var sr = "" + r;
    sr = sr.trim();
    if (sr === "") continue;
    some = true;
    res += sep + sr;
    sep = separator;
  }

  if (some) return res;else return deftxt;
};
/**
 * @returns {String} the default currency wich is taken from AP_OPZIONI  with values opt("GLOBALE", "DIVRIF"). If there is no such Opzione "HRK" is returned instead
 */


UiUtils.prototype.defaultCurrency = function () {
  var divrif = opt("GLOBALE", "DIVRIF");
  if (divrif) return divrif;
  return "HRK";
};
/**
 * @returns {String} the default language wich is "IT"
 */


UiUtils.prototype.defaultLang = function () {
  return "IT";
};
/**
 * @returns {Stirng} The default locale from the number formatter
 */


UiUtils.prototype.defaultLocale = function () {
  return 'it-IT';
};
/**
 * 
 * @param {*} val 
 * @param {*} currency 
 * @param {*} defVal 
 */


UiUtils.prototype.money = function (val, currency, defVal) {
  if (val === null || val === undefined) {
    return defVal;
  }

  if (!currency) currency = this.defaultCurrency();
  return NumberFormatter$1.format(val, NumberFormatter$1.getDefaultLocale()) + " " + currency;
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.number4 = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return NumberFormatter$1.format4FractionDigits(val, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.number = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return NumberFormatter$1.format(val, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.numberInt = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return NumberFormatter$1.formatInt(val, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} numDigits 
 * @param {*} defVal 
 */


UiUtils.prototype.numberDigits = function (val, numDigits, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return NumberFormatter$1.formatDigits(val, numDigits, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 */


UiUtils.prototype.translate = function () {
  var args = arguments;
  if (!args || args.length < 3 || args.length % 2 === 0) throw new Error("invalid arguments for UiUtils.translate(). example: .translate(val, 'val1', 'Valore 1', 'val2', 'Valore 2'...)");
  var v = args[0];
  if (v === undefined || v === null) return "";
  var value = "" + v;

  for (var i = 1; i < args.length; i += 2) {
    var val = "" + args[i];
    if (val === val) return "" + args[i + 1];
  }

  return value;
};
/**
 * 
 * @param {*} val 
 */


UiUtils.prototype.sign = function (val) {
  if (val === null || val === undefined || isNaN(val) || val === 0) {
    return "";
  }

  if (val > 0) return "+";else return "-";
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.perc = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return NumberFormatter$1.intPercent(val, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.decimalPerc = function (val, defVal) {
  if (val === null || val === undefined) {
    return defVal || "";
  }

  return NumberFormatter$1.percent(val, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 * @param {*} email 
 * @param {*} defNoEmail 
 * @param {*} className 
 */


UiUtils.prototype.email = function (email, defNoEmail, className) {
  if (!email) return defNoEmail || "";
  return /*#__PURE__*/React.createElement("a", {
    href: 'mailto:' + email,
    className: 'email ' + (className ? className : '')
  }, email);
};
/**
 * 
 * @param {*} tel 
 * @param {*} defNoTel 
 * @param {*} className 
 */


UiUtils.prototype.tel = function (tel, defNoTel, className) {
  if (!tel) return defNoTel || "";
  return /*#__PURE__*/React.createElement("a", {
    href: 'tel:' + tel,
    className: 'phone ' + (className ? className : '')
  }, tel);
};
/**
 * 
 * @param {*} dt 
 * @param {*} defDt 
 */


UiUtils.prototype.date = function (dt, defDt) {
  return exp$4.dataFormatterShort(dt, defDt, NumberFormatter$1.getDefaultLocale());
};
/**
 * 
 * @param {*} codDominio 
 * @param {*} trascVal 
 */


UiUtils.prototype.domainByTrascVal = function (codDominio, trascVal) {
  var dd = domain(codDominio);
  var ret = null;
  if (!dd) return ret;
  dd.forEach(function (dom, index) {
    if (!ret && dom.trascVal === trascVal) {
      ret = dom;
    }
  });
  return ret;
};
/**
 * 
 * @param {*} dom 
 * @param {*} trascVal 
 * @param {*} defVal 
 */


UiUtils.prototype.labelDomainTrascVal = function (dom, trascVal, defVal) {
  var d = this.domainByTrascVal(dom, trascVal);
  if (!d) return defVal || "";
  return d.desDom;
};
/**
 * 
 * @param {*} dom 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.labelDomain = function (dom, val, defVal) {
  var d = domainVal(dom, val);
  if (!d) return defVal || "";
  return d.desDom;
};
/**
 * 
 * @param {*} dom 
 * @param {*} val 
 * @param {*} defVal 
 */


UiUtils.prototype.colorDomain = function (dom, val, defVal) {
  var d = domainVal(dom, val);
  if (!d) return defVal || "";
  return d.trascVal;
};
/**
 * 
 * @param {*} text 
 */


UiUtils.prototype.slugify = function (text) {
  if (text === null || text === undefined) return "";
  return text.toString().toLowerCase().replace(/[\s\-\_\/]+/g, '-') // Replace spaces and separators with -
  .replace(/[^\w\-]+/g, '') // Remove all non-word chars
  .replace(/\-\-+/g, '-') // Replace multiple - with single -
  .replace(/^-+/, '') // Trim - from start of text
  .replace(/-+$/, ''); // Trim - from end of text
};
/**
 * 
 * @param {*} text 
 */


UiUtils.prototype.clean = function (text) {
  if (text === null || text === undefined) return "";
  return text.toString().toLowerCase().replace(/[\s\-\_\/]+/g, '_') // Replace spaces and separators with -
  .replace(/[^\w\_]+/g, '') // Remove all non-word chars
  .replace(/\_\_+/g, '_') // Replace multiple _ with single _
  .replace(/^_+/, '') // Trim _ from start of text
  .replace(/_+$/, ''); // Trim _ from end of text
};
/**
 * 
 * @param {*} elem 
 * @param {*} offset 
 * @param {*} completeFunc 
 * @param {*} duration 
 */


UiUtils.prototype.scrollTo = function (elem, offset, completeFunc, duration) {
  var container = jquery__default["default"]('body');
  var scrollTo = jquery__default["default"](elem);
  if (scrollTo.length === 0) return;
  var pos = scrollTo.offset().top - (offset || 0);
  container.animate({
    scrollTop: pos - container.offset().top
  }, {
    duration: duration || 500,
    // easing: "easein",
    complete: completeFunc
  });
};
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */


UiUtils.prototype.detectIE = function () {
  var ua = window.navigator.userAgent; // Test values; Uncomment to check result …
  // IE 10
  // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
  // IE 11
  // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
  // Edge 12 (Spartan)
  // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
  // Edge 13
  // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return 0;
};
/**
 * 
 * @param {*} elem 
 */


UiUtils.prototype.getCursorPosition = function (elem) {
  // Initialize
  var iCaretPos = null; // IE Support

  if (elem.selection) {
    input.focus();
    var sel = document.selection.createRange();
    var selLen = document.selection.createRange().text.length;
    sel.moveStart('character', -input.value.length);
    iCaretPos = sel.text.length - selLen;
  } // Chrome/Firefox support
  else if (elem.selectionStart || elem.selectionStart === '0') {
    iCaretPos = elem.selectionStart;

    if (this.detectIE() >= 11) ;
  } // Return results


  return iCaretPos;
};
/**
 * 
 * @param {*} elem 
 * @param {*} cursorPos 
 */


UiUtils.prototype.setCursorPosition = function (elem, cursorPos) {
  if (!elem || cursorPos === null || cursorPos === undefined || cursorPos < 0) return;

  if (elem.createTextRange) {
    if (elem.style.textAlign === 'right') {
      cursorPos = elem.value.length - cursorPos; //cursorPos = -cursorPos;
    }

    var range = elem.createTextRange();
    range.move('character', cursorPos);
    range.select();
  } else if (elem.selectionStart) {
    elem.focus();

    if (elem.style.textAlign === 'right') {
      cursorPos = elem.value.length - cursorPos;
    }

    elem.setSelectionRange(cursorPos, cursorPos);
  } else elem.focus();
};
/**
 * private.
 * assume if not null, a and b are the same type.
 * @param {*} a 
 * @param {*} b 
 */


UiUtils.prototype.builtinComparator = function (a, b) {
  if (a === undefined) a = null;
  if (b === undefined) b = null;
  if (a === null && b === null) return 0;
  if (a === null) return 1;
  if (b === null) return -1; // check on type date

  if (a instanceof Date) {
    var dateA = a.getTime();
    var dateB = b.getTime();
    return dateA < dateB ? -1 : dateA === dateB ? 0 : -1;
  } // any not number


  if (isNaN(a)) {
    var aa = a.toString().toLowerCase();
    var bb = b.toString().toLowerCase();
    return aa.localeCompare(bb);
  }

  if (a < b) return -1;
  if (a === b) return 0;
  return 1;
};
/**
 * 
 * @param {*} val 
 * @param {*} numZero 
 */


UiUtils.prototype.zeroFill = function (val, numZero) {
  var zeroToAdd = numZero;
  var strVal = "";
  if (val !== null && val !== undefined) strVal = "" + val;
  var res = "";
  zeroToAdd -= strVal.length;

  for (var i = 0; i < zeroToAdd; i++) {
    res += "0";
  }

  res += strVal;
  return res;
};

var exp$3 = new UiUtils();

var DEF_CONFIG = {
  timeoutLoad: 10,
  timeoutEndload: 700
};

function _callDispatch(callback, dispatch, getState) {
  // callback(dispatch, getState)
  dispatch(function (dispatch, getState) {
    return callback(dispatch, getState);
  });
}
/**
 * @class DiffLoaderUI
 * @classdesc Gestione in differita load/unload.
 */


var DiffLoaderUI = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {*} config 
   */
  function DiffLoaderUI(config) {
    this.requests = {};
    /** @type {Object} */

    this.config = _extends({}, DEF_CONFIG, config);
  }
  /**
   * @memberof DiffLoaderUI#
   * @param {*} urlId 
   * @param {*} options 
   */


  var _proto = DiffLoaderUI.prototype;

  _proto._getId = function _getId(urlId, options) {
    if (options) {
      if (options.loadNoDelay) return null;

      if (options.loadHandler && options.endloadHandler) {
        return null;
      }

      if (options.loadId) {
        return exp$3.clean(options.loadId);
      }
    }

    if (urlId) return exp$3.clean(urlId);
    return "__AGUI_LOADER_GENERAL__";
  }
  /**
   * @memberof DiffLoaderUI#
   * @param {*} urlId 
   * @param {*} callbackLoad 
   * @param {*} dispatch 
   * @param {*} options 
   */
  ;

  _proto.load = function load(urlId, callbackLoad, dispatch, options) {
    var self = this;
    if (!callbackLoad || !dispatch) return;
    var timeoutLoad = options && options.timeoutLoad || this.config.timeoutLoad;

    var id = this._getId(urlId, options);

    if (!id) {
      // || timeoutLoad < 1) {
      // callbackLoad(dispatch);
      _callDispatch(callbackLoad, dispatch);

      return;
    }

    var req = this.requests[id]; //console.debug("diffLoaderUI.load", id);

    if (!req) {
      req = {
        id: id,
        callbackLoad: callbackLoad,
        dispatch: dispatch,
        inload: false,
        mustLoad: true,
        timeoutLoadRef: null,
        numRequests: 0
      };
      this.requests[id] = req;

      if (!req.timeoutLoadRef) {
        req.timeoutLoadRef = setTimeout(function () {
          //console.debug("diffLoaderUI SHOW load", id);
          req.numRequests++;

          if (!req.inLoad) {
            req.timeoutLoadRef = null;

            if (req.mustLoad) {
              req.mustLoad = false;
              req.inload = true;

              _callDispatch(req.callbackLoad, req.dispatch);
            } else {
              self._cleanupRequest(req.id);
            }
          }
        }, timeoutLoad);
      }
    } else {
      req.numRequests++; //console.debug("diffLoaderUI load numreq++", id);
    }
  }
  /**
   * @memberof DiffLoaderUI#
   * @param {*} urlId 
   * @param {*} callbackEndload 
   * @param {*} dispatch 
   * @param {*} options 
   */
  ;

  _proto.endload = function endload(urlId, callbackEndload, dispatch, options) {
    var self = this;
    if (!callbackEndload || !dispatch) return null;
    var timeoutEndload = options && options.timeoutEndload || this.config.timeoutEndload;

    var id = this._getId(urlId, options);

    if (!id) {
      // || timeoutEndload < 1) {
      // dispatch((dispatch) => callbackEndload(dispatch));
      _callDispatch(callbackEndload, dispatch);

      return;
    }

    var req = this.requests[id]; //console.debug("diffLoaderUI endload", id);

    if (!req) {
      // req = {
      //     id: id,
      //     callbackEndload: callbackEndload,
      //     inload: false,
      //     dispatch: dispatch,
      //     timeoutEndloadRef: null,
      //     numRequests: 0
      // };
      // this.requests[id] = req;
      console.debug("endload chiamato prima del load", id);
      return;
    }

    if (!req.callbackEndload) {
      req.callbackEndload = callbackEndload;
    }

    if (req.numRequests <= 1) {
      // if (req.timeoutEndloadRef) {
      //    clearTimeout(req.timeoutEndloadRef); 
      //    req.timeoutEndloadRef = null;
      // }
      req.mustLoad = false;

      if (!req.timeoutEndloadRef) {
        req.timeoutEndloadRef = setTimeout(function () {
          console.debug("diffLoaderUI HIDE load", id);
          req.numRequests = 0;
          req.timeoutEndloadRef = null;

          if (req.inload) {
            // req.callbackEndload(req.dispatch);
            _callDispatch(req.callbackEndload, req.dispatch);

            req.inload = false;

            self._cleanupRequest(req.id);
          }
        }, timeoutEndload);
      }
    } else {
      req.numRequests--; // console.debug("diffLoaderUI endload numReq--", id);
    }
  }
  /**
   * @memberof DiffLoaderUI#
   * @param {*} id 
   */
  ;

  _proto._cleanupRequest = function _cleanupRequest(id) {
    if (!this.requests[id]) return; // console.debug("diffLoaderUI cleanup", id);

    delete this.requests[id];
  };

  return DiffLoaderUI;
}();

/**
 * Armundia REST communication.
 * 
 * BASED on JQuery.
 * @author G. Annunziata
 */
var SERVER = "localhost"; //const SERVER = "192.168.121.113";

var DEFAULT_OPTS = {
  server: SERVER,
  restBaseurl: null,
  // mandatory
  pathsToSkip: null,
  jsessionidRecoverHandler: null,
  loadHandler: null,
  endloadHandler: null,
  errorHandler: null,
  doLogoutHandler: null,
  useStub: true,
  // TODO settare come isDev
  serveridRecoverHandler: null,
  sessionConf: {
    sessionExpiredHandler: null,
    sessionExpiredHandlerTimeout: null
  },
  stringConversationId: "conversationId"
};
var sessionExpiredHandlerId = null; // class WebRest {

/**
 * @class
 * @classdesc Armundia REST communication.
 * create a (singleton) WebRest to use inside a SPA.
 * @constructor
 * 
 * @param {string} server_or_options server domain, i.e. localhost, 192.168.121.113, privatebank.intesasanpaolo.ch -
 *  if omitted, became 'localhost'
 * OR you can use this ONE parameter as object contains all parameters described below
 * 
 * @param {string} restBaseurl base url, fully qualified url, i.e. https://localhost:9000/rest/  - MANDATORY
 * @param {string[]} pathsToSkip array of paths (string) will be skipped can be null
 * @param {function} jsessionidRecoverHandler handler (function) to get jsessionid when WebRest needs. function must return jsessionid or null
 * @param {function} loadHandler handler (function) to signal when WebRest in in loading
 * @param {function} endloadHandler handler (function) to signal when WebRest end loading (in error or not)
 * @param {function} errorHandler handler (function) to handle error message (passed as parameter)
 * @param {function} doLogoutHandler handler (function) to signal needs to execute logout
 * @param {string} useStub activate handling of file stubs (with path starts with string passed)
 * @param {string} serveridRecoverHandler handler (function) to get serverid when WebRest needs. function must return serverid or null
 * @param {obj} sessionConf session configuration formed by @param {function} sessionExpiredHandler and @param {function} sessionExpiredHandlerTimeout; sessionExpiredHandler is called after sessionExpiredHandlerTimeout minutes
 * @param {string} stringConversationId string for configuring 'conversationId' as string at url forming
 */

function WebRest(server, restBaseurl, pathsToSkip, jsessionidRecoverHandler, loadHandler, endloadHandler, errorHandler, doLogoutHandler, useStub, serveridRecoverHandler, sessionConf, stringConversationId) {
  if (typeof server === 'object') {
    var opts = lodash.extend(DEFAULT_OPTS, server);
    this.server = opts.server;
    restBaseurl = opts.restBaseurl;
    pathsToSkip = opts.pathsToSkip;
    jsessionidRecoverHandler = opts.jsessionidRecoverHandler;
    loadHandler = opts.loadHandler;
    endloadHandler = opts.endloadHandler;
    errorHandler = opts.errorHandler;
    doLogoutHandler = opts.doLogoutHandler;
    useStub = opts.useStub;
    serveridRecoverHandler = opts.serveridRecoverHandler;
    sessionConf = opts.sessionConf;

    if (sessionConf) {
      sessionConf.sessionExpiredHandlerTimeout = NumberUtils.convertMinutesInMilliseconds(sessionConf.sessionExpiredHandlerTimeout);
    }

    stringConversationId = opts.stringConversationId;
  } else if (typeof server === 'string') {
    if (!server) {
      server = SERVER;
    }

    this.server = server;
  }

  if (restBaseurl === null || restBaseurl === undefined) {
    throw new Error("try to instance WebRest without restBaseurl parameter");
  }

  if (useStub === undefined) useStub = null;
  this.restBaseurl = restBaseurl;
  this.pathsToSkip = pathsToSkip;
  this.jessionidRecoverHandler = jsessionidRecoverHandler;
  this.loadHandler = loadHandler;
  this.endloadHandler = endloadHandler;
  this.errorHandler = errorHandler;
  this.doLogoutHandler = doLogoutHandler;
  this.useStub = useStub;
  this.serveridRecoverHandler = serveridRecoverHandler;
  this.sessionConf = sessionConf;
  this.diffLoaderUI = new DiffLoaderUI();

  if (stringConversationId) {
    this.stringConversationId = stringConversationId;
  } // this.loadHandler = this.loadHandler.bind(this);
  // this.endloadHandler = this.endloadHandler.bind(this);

}
/**
 * @returns {String} The actual JSessionId
 */


WebRest.prototype.getJsessionid = function () {
  var jid = null;

  if (this.jessionidRecoverHandler) {
    var j = this.jessionidRecoverHandler();
    if (j) jid = j;
  }

  return jid;
};
/**
 * @returns {String} The actual server ID
 */


WebRest.prototype.getServerId = function () {
  var serverId = null;

  if (this.serveridRecoverHandler) {
    var j = this.serveridRecoverHandler();
    if (j) serverId = j;
  }

  return serverId;
};
/**
 * @returns {String} Application base URL
 */


WebRest.prototype.getBaseUrl = function () {
  return this.restBaseurl;
};
/**
 * @returns {String} Actual conversation ID opened
 */


WebRest.prototype.getStringConversationId = function () {
  return this.stringConversationId;
};
/**
 * Create Rest link from the path and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} options Object with the options to be passed
 * @param {*} toSkip 
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.createRestLink = function (path, options, toSkip) {
  var url;
  var jsessionid = null;

  if (this.useStub && path.startsWith(this.useStub)) {
    url = path;
  } else {
    jsessionid = this.getJsessionid();
    url = this.restBaseurl + path;
  }

  if (jsessionid !== null && window.location.hostname === this.server) {
    // this.server
    var skip = false;

    if (toSkip) {
      for (var i = 0; i < toSkip.length; i++) {
        var psk = toSkip[i];

        if (psk === path) {
          skip = true;
          break;
        }
      }
    }

    if (!skip) {
      var ind = url.indexOf('?');

      if (ind === -1) {
        url = url + ";jsessionid=" + jsessionid;
      } else {
        var preurl = url.substring(0, ind);
        var posturl = url.substring(ind, url.length);
        url = preurl + ";jsessionid=" + jsessionid + posturl;
      }
    }
  }

  if (options && options['conversationId']) {
    var _ind = url.indexOf('?');

    if (_ind === -1) {
      url = url + "?" + this.stringConversationId + "=" + options['conversationId'];
    } else {
      url = url + "&" + this.stringConversationId + "=" + options['conversationId'];
    }
  }

  return url;
};
/**
 * Make a POST call to the server with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.post = function (path, body, dispatch, options) {
  var _this = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.post: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options);
  console.log("[WebRest.post]: " + url, body);
  var temp = null;

  if (body !== null) {
    try {
      temp = JSON.stringify(body);
    } catch (e) {
      console.error("errore stringify body for", body);
      console.error(e);
      return {};
    }
  }

  var opts = Object.assign({}, {
    cache: false,
    contentType: 'application/json; charset=utf-8',
    dataType: "json",
    //dataType: The type of data that you're expecting back from the server
    withCredentials: false
  }, options);

  this._loading(url, dispatch, opts);

  return jquery__default["default"].ajax({
    url: url,
    data: temp,
    cache: false,
    dataType: opts.dataType,
    contentType: opts.contentType,
    type: "POST",
    headers: {
      'SERVER-ID': this.getServerId()
    },
    xhrFields: {
      withCredentials: opts.withCredentials
    }
  }).then(function (data) {
    console.log("[WebRest.post] ok url:" + url, data);

    _this._endload(url, dispatch, options);

    return data;
  }, function (reject) {
    console.log("[WebRest.post] reject url:" + url, reject);

    _this._endload(url, dispatch, options);

    if (reject.status === 200) {
      try {
        return JSON.parse(reject.responseText);
      } catch (ep) {
        console.warn("REJECT with 200 - try to parse error", ep);
        return reject.responseText;
      }
    } else if (reject.status === 405) {
      // Ritento nuovamente la chiamata
      if (!options) options = {};
      if (!options.count) options.count = 0;

      if (options.count < 4) {
        options.count = options.count + 1;
        return post(path, body, dispatch, options);
      }
    }

    _this._handleError(dispatch, reject, options);

    return reject;
  });
};
/**
 * Make a GET call to the server with the path and options passed 
 * @param {String} path URL for the call to be made
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.get = function (path, dispatch, options) {
  return this.get(path, null, dispatch, options);
};
/**
 * Make a GET call to the server with the path and options passed 
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the GET call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.get = function (path, body, dispatch, options) {
  var _this2 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.get: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options);
  console.log("[WebRest.get]: " + url, body);
  var temp = null; // if (body !== null) {
  //     try {
  //         temp = JSON.stringify(body);
  //     } catch (e) {
  //         console.error("errore stringify body for", url, body);
  //         console.error(e);
  //         return {};
  //     }
  // }

  var opts = Object.assign({}, {
    cache: false,
    contentType: 'application/json; charset=utf-8',
    dataType: "json",
    //dataType: The type of data that you're expecting back from the server
    withCredentials: false
  }, options);

  this._loading(url, dispatch, opts);

  return jquery__default["default"].ajax({
    url: url,
    cache: false,
    data: temp,
    dataType: opts.dataType,
    contentType: opts.contentType,
    headers: {
      'SERVER-ID': this.getServerId()
    },
    xhrFields: {
      withCredentials: opts.withCredentials
    },
    type: "GET"
  }).then(function (data) {
    console.log("[WebRest.get] ok url:" + url, data);

    _this2._endload(url, dispatch, options);

    return data;
  }, function (reject) {
    _this2._endload(url, dispatch, options);

    if (reject.status === 200) {
      try {
        return JSON.parse(reject.responseText);
      } catch (ep) {
        console.warn("REJECT with 200 - try to parse error", ep);
        return reject.responseText;
      }
    }

    console.warn("[WebRest.get] reject url:" + url, reject);

    _this2._handleError(dispatch, reject, options);

    return reject;
  });
};
/**
 * Make a POST FORM call to the server with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST FORM call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.postForm = function (path, body, dispatch, options) {
  var _this3 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.postForm: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options, this.pathsToSkip);
  console.log("[WebRest.postForm]: " + url);
  var temp = null;

  if (body !== null) {
    if (body instanceof FormData) {
      temp = body;
    } else {
      temp = jquery__default["default"].param(body);
    }
  }

  var opts = Object.assign({}, {
    cache: false,
    contentType: 'application/x-www-form-urlencoded; charset=utf-8',
    processData: true,
    dataType: "json",
    //dataType: The type of data that you're expecting back from the server
    withCredentials: false
  }, options);

  this._loading(url, dispatch, opts);

  return jquery__default["default"].ajax({
    url: url,
    type: "POST",
    cache: opts.cache,
    data: temp,
    dataType: opts.dataType,
    processData: opts.processData,
    contentType: opts.contentType,
    headers: {
      'SERVER-ID': this.getServerId()
    },
    xhrFields: {
      withCredentials: opts.withCredentials
    }
  }).then(function (data) {
    console.log("[WebRest.postForm] ok url:" + url, data);

    _this3._endload(url, dispatch, options);

    return data;
  }, function (reject) {
    console.log("[WebRest.postForm] reject url:" + url, reject);

    _this3._endload(url, dispatch, options);

    if (reject.status === 200) {
      try {
        return JSON.parse(reject.responseText);
      } catch (ep) {
        console.warn("REJECT with 200 - try to parse error", ep, reject);
        return reject.responseText;
      }
    } else if (reject.status === 405) {
      // Ritento nuovamente la chiamata
      if (!options.count) options.count = 0;

      if (options.count < 4) {
        options.count = options.count + 1;
        return postForm(path, body, dispatch, options);
      }
    }

    _this3._handleError(dispatch, reject, options);

    return reject;
  });
};
/**
 * Download a File from a POST FORM call made with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFilePojo = function (path, body, dispatch, options) {
  var _this4 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.downloadFilePojo: cannot have path parameter null/undefined");
    return {};
  } //il servizio Rest deve restituire un FilePojo


  return this.postForm(path, body, dispatch, options).then(function (resolve) {
    console.log('\t downloadFilePojo: resolve');

    _this4._resolveFilePojo(resolve);

    return resolve;
  }, function (reject) {
    console.log('\t downloadFilePojo: reject');
    return reject;
  });
};
/**
 * Download a File from a POST call made with the path, body and options passed
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFilePojoPost = function (path, body, dispatch, options) {
  var _this5 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.downloadFilePojoPost: cannot have path parameter null/undefined");
    return {};
  } //il servizio Rest deve restituire un FilePojo


  return this.post(path, body, dispatch, options).then(function (resolve) {
    console.log('\t downloadFilePojoPost: resolve');

    _this5._resolveFilePojo(resolvem);

    return resolve;
  }, function (reject) {
    console.log('\t downloadFilePojoPost: reject');
    return reject;
  });
};
/**
 * 
 * @param {String} path URL for the call to be made
 * @param {Object} body The object with the parameters to be passed at the POST call
 * @param {Dispatch} dispatch The dispatch of the reducer that is needed later
 * @param {Object} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFileStreamPOST = function (path, body, dispatch, options) {
  var _this6 = this;

  this._resetExpiredSessionHandler(dispatch, options);

  if (path === undefined || path === null) {
    console.error("WebRest.downloadFileStreamPOST: cannot have path parameter null/undefined");
    return {};
  }

  var url = this.createRestLink(path, options, this.pathsToSkip);
  console.log("[WebRest.downloadFileStreamPOST]: " + url);
  var temp = null;

  if (body !== null) {
    if (body instanceof FormData) {
      temp = body;
    } else {
      temp = jquery__default["default"].param(body);
    }
  }

  var opts = Object.assign({}, {
    contentType: 'application/x-www-form-urlencoded; charset=utf-8'
  }, options);

  this._loading(url, dispatch, opts); // Use XMLHttpRequest instead of Jquery jqueryajax


  var xhr = new XMLHttpRequest();

  xhr.onreadystatechange = function () {
    console.log("[WebRest.downloadFileStreamPOST] onreadystatechange " + xhr.readyState);

    if (xhr.readyState === 4 && xhr.status === 200) {
      var contentType = xhr.getResponseHeader("Content-Type");
      console.log("[WebRest.downloadFileStreamPOST] contentType: " + contentType);
      var contentDisposition = xhr.getResponseHeader("Content-Disposition");
      console.log("[WebRest.downloadFileStreamPOST] contentDisposition: " + contentDisposition);

      var fileName = _this6._getFileNameByContentDisposition(contentDisposition); // Trick for making downloadable link


      var link = document.createElement('a');
      link.href = window.URL.createObjectURL(xhr.response); // Give filename you wish to download

      link.download = fileName;
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click(); //remove the link when done

      document.body.removeChild(link);
    }
  };

  xhr.onloadend = function () {
    console.log("[WebRest.downloadFileStreamPOST] onloadend "); //The loadend event is fired when a request has completed, whether successfully (after load) or unsuccessfully (after abort or error).

    _this6._endload(url, dispatch, options);
  }; // Post data to URL which handles post request


  xhr.open("POST", url);
  xhr.setRequestHeader("Content-Type", opts.contentType); // You should set responseType as blob for binary responses

  xhr.responseType = 'blob';
  xhr.send(temp);
  return Promise.resolve();
};
/**
 * 
 * @param {*} path URL for the call to be made
 * @param {*} options Object with the options to be passed
 * @returns {any} The response from the REST call done
 */


WebRest.prototype.downloadFileStreamGET = function (path, options) {
  if (path === undefined || path === null) {
    console.error("WebRest.downloadFileStreamGET: cannot have path parameter null/undefined");
    return {};
  }

  console.log("[WebRest.downloadFileStreamGET]: " + path);
  var link = document.createElement('a'); //link.download = "nomeFile.pdf";

  link.href = this.createRestLink(path, options);
  link.target = "_blank";
  document.body.appendChild(link);
  link.click(); //remove the link when done

  document.body.removeChild(link);
  return Promise.resolve();
};

WebRest.prototype._getFileNameByContentDisposition = function (contentDisposition) {
  var regex = /filename[^;=\n]*=(UTF-8(['"]*))?(.*)/;
  var matches = regex.exec(contentDisposition);
  var filename;

  if (matches !== null && matches[3]) {
    filename = matches[3].replace(/['"]/g, '');
  }

  return decodeURI(filename);
}.bind(undefined);

WebRest.prototype._resolveFilePojo = function (resolve) {
  var mimeType = "application/octet-stream";

  if (resolve.mimeType) {
    console.log("mimeType: " + resolve.mimeType);
    mimeType = resolve.mimeType;
  }

  var msie = window.navigator.userAgent.indexOf("MSIE ");

  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) // If Internet Explorer
    {
      console.log("Browser Internet Explorer");

      var blob = this._b64toBlob(resolve.contentBase64, mimeType);

      window.navigator.msSaveOrOpenBlob(blob, resolve.name);
    } else {
    var link = document.createElement('a');
    link.download = resolve.name;
    link.href = "data:" + mimeType + ";base64," + resolve.contentBase64;
    link.target = "_blank";
    document.body.appendChild(link);
    link.click(); //remove the link when done

    document.body.removeChild(link); //window.open("data:" + mimeType + ";base64, " + resolve.contentBase64, resolve.name);
  }
};

WebRest.prototype._b64toBlob = function (b64Data, contentType, sliceSize) {
  contentType = contentType || '';
  sliceSize = sliceSize || 512;
  var byteCharacters = atob(b64Data);
  var byteArrays = [];

  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);

    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }

  var blob = new Blob(byteArrays, {
    type: contentType
  });
  return blob;
};

WebRest.prototype._loading = function (url, dispatch, options) {
  if (!dispatch) return;
  if (options && options.loading !== null && options.loading !== undefined && !options.loading) return;
  var lh = options && options.loadHandler || this.loadHandler;
  if (!lh) return;
  this.diffLoaderUI.load(url, lh, dispatch, options);
};

WebRest.prototype._endload = function (url, dispatch, options) {
  if (!dispatch) return;
  if (options && options.loading !== null && options.loading !== undefined && !options.loading) return;
  var eh = options && options.endloadHandler || this.endloadHandler;
  if (!eh) return;
  this.diffLoaderUI.endload(url, eh, dispatch, options);
};

WebRest.prototype._inError = function (dispatch, mesg, statusCode, options, stacktrace) {
  console.warn('WebRest error:', mesg, stacktrace, " - status code:", statusCode);
  if (!dispatch || !this.errorHandler) return;
  var eh = options && options.errorHandler || this.errorHandler;
  eh(dispatch, mesg, statusCode, options, stacktrace);
};

WebRest.prototype._handleError = function (dispatch, reject, options) {
  var message = null;
  var stacktrace = null;

  if (reject.responseJSON && reject.responseJSON.message) {
    message = reject.responseJSON.message;
    stacktrace = reject.responseJSON.stackTrace;
  } else {
    message = this._getAjaxErrorMessage(reject);
    if (reject.responseText && reject.responseText.indexOf("<html") >= 0) stacktrace = reject.responseText;
  }

  if (reject.status === 401 || reject.status === 400) {
    console.log("[WebRest] errore 400/401");
  } else if (reject.status === 403) {
    console.log("[WebRest] sessione scaduta (faccio logout prima del messaggio)");

    this._logout(dispatch);
  }

  this._inError(dispatch, message, reject.status, options, stacktrace);
};

WebRest.prototype._logout = function (dispatch) {
  if (dispatch && this.doLogoutHandler) this.doLogoutHandler(dispatch);
};

WebRest.prototype._getAjaxErrorMessage = function (reject) {
  console.log("getAjaxErrorMessage", reject);
  var message = "unknown error";

  if (reject) {
    console.log("Request Failed: " + reject.statusText + ", " + reject.responseJSON + ' ' + reject.status);

    if (reject.readyState === 4) {
      // HTTP error (can be checked by XMLHttpRequest.status and XMLHttpRequest.statusText)
      message = reject.status + " - " + reject.statusText;
    } else if (reject.readyState === 0) {
      message = "Network connection error";
    } else {
      message = reject.status + " - " + reject.statusText;
    }
  }

  return message;
};

WebRest.prototype._resetExpiredSessionHandler = function (dispatch, options) {
  var sessionConf = this.sessionConf;

  if (options && options.skipResetSession) {
    return;
  }

  if (sessionConf && dispatch) {
    var sessionExpiredHandler = sessionConf.sessionExpiredHandler;
    var sessionExpiredHandlerTimeout = sessionConf.sessionExpiredHandlerTimeout;

    if (sessionExpiredHandler && sessionExpiredHandlerTimeout && sessionExpiredHandlerTimeout > 0) {
      if (sessionExpiredHandlerId) {
        clearTimeout(sessionExpiredHandlerId);
      }

      sessionExpiredHandlerId = setTimeout(function () {
        sessionExpiredHandler(dispatch);
      }, sessionExpiredHandlerTimeout);
    }
  }
};

/**
 * @class
 * @classdesc Armundia Utils
 * This Object is treated as a class so the usage would be 'new common.Utils()'
 * @constructor
 */

function Utils() {
  this.lut = null;
}
/**
 * 
 * @param {*} pre 
 */


Utils.prototype.uuid = function (pre) {
  return lodash.uniqueId(pre);
};
/**
 * 
 */


Utils.prototype._assureLut = function () {
  if (this.lut) return;
  this.lut = [];

  for (var i = 0; i < 256; i++) {
    this.lut[i] = (i < 16 ? '0' : '') + i.toString(16);
  }
};
/**
 * 
 */


Utils.prototype.guid = function () {
  this._assureLut();

  var d0 = Math.random() * 0xffffffff | 0;
  var d1 = Math.random() * 0xffffffff | 0;
  var d2 = Math.random() * 0xffffffff | 0;
  var d3 = Math.random() * 0xffffffff | 0;
  var lut = this.lut;
  return lut[d0 & 0xff] + lut[d0 >> 8 & 0xff] + lut[d0 >> 16 & 0xff] + lut[d0 >> 24 & 0xff] + '_' + lut[d1 & 0xff] + lut[d1 >> 8 & 0xff] + '_' + lut[d1 >> 16 & 0x0f | 0x40] + lut[d1 >> 24 & 0xff] + '_' + lut[d2 & 0x3f | 0x80] + lut[d2 >> 8 & 0xff] + '_' + lut[d2 >> 16 & 0xff] + lut[d2 >> 24 & 0xff] + lut[d3 & 0xff] + lut[d3 >> 8 & 0xff] + lut[d3 >> 16 & 0xff] + lut[d3 >> 24 & 0xff];
};
/**
 * 
 * @param {*} val 
 */


Utils.prototype.isNil = function (val) {
  return val === undefined || val === null || val.toString() === "" || val.toString().trim() === "";
};
/**
 * 
 */


Utils.prototype.strjoin = function () {
  if (arguments.length < 2) return "";
  var separator = arguments[0];
  var res = "";
  var sep = "";

  for (var i = 1; i < arguments.length; i++) {
    var r = arguments[i];
    if (!r) continue;
    res += sep + r;
    sep = separator;
  }

  return res;
};
/**
 * 
 * @param {*} base 
 * @param {*} separator 
 * @param {*} others 
 */


Utils.prototype.union = function (base, separator, others) {
  var all = {};

  if (!separator) {
    separator = " ";
  }

  if (base) {
    var bb = base.split(separator);
    if (bb === null || bb.length < 2) all[base] = base;else {
      for (var i = 0; i < bb.length; i++) {
        var b = bb[i];
        all[b] = b;
      }
    }
  }

  if (others) {
    var oo = others.split(separator);

    if (oo === null || oo.length < 2) {
      var o = others;

      if (o.startsWith("-")) {
        o = o.substring(1);
        all[o] = null;
      } else {
        all[o] = o;
      }
    } else {
      for (var _i = 0; _i < oo.length; _i++) {
        var _o = oo[_i];

        if (_o.startsWith("-")) {
          _o = _o.substring(1);
          all[_o] = null;
        } else {
          all[_o] = _o;
        }
      }
    }
  }

  var res = "";
  var sep = "";
  var keys = Object.keys(all);

  for (var _i2 = 0; _i2 < keys.length; _i2++) {
    var k = keys[_i2];
    if (!k) continue;
    var _o2 = all[k];
    if (_o2 === null) continue;
    res += sep + k;
    sep = separator;
  }

  return res;
};
/**
 * 
 * @param {*} obj 
 */


Utils.prototype.toArray = function (obj) {
  if (obj === undefined || obj === null) return null;
  var kk = Object.keys(obj);
  var res = [];

  for (var i = 0; i < kk.length; i++) {
    var k = kk[i];
    res.push(obj[k]);
  }

  return res;
};
/**
 * 
 * @param {*} fieldPath 
 * @param {*} item 
 */


Utils.prototype.getVal = function (fieldPath, item) {
  if (item === undefined || item === null || fieldPath === undefined || fieldPath === null) return null; // use path to get value

  var idx = ("" + fieldPath).indexOf('.');
  if (idx === -1) return item[fieldPath];else {
    var pp = fieldPath.split('.');
    var o = item;

    for (var i = 0; i < pp.length; i++) {
      o = o[pp[i]];

      if (o === null || o === undefined) {
        o = null;
        break;
      }
    }

    return o;
  }
};
/**
 * 
 * @param {*} text 
 */


Utils.prototype.toId = function (text) {
  if (!text) return null; // da https://gist.github.com/mathewbyrne/1280286

  return text.toString().toLowerCase().replace(/[^\w]+/g, ' ') // Remove all non-word chars
  .trim().replace(/\s+/g, '_') // Replace spaces with _
  .replace(/\_\_+/g, '_'); // Replace multiple _ with single _
};
/**
 * Aggiunge al dominio passato in ingresso (oggetto di tipo ApDom pervenuto
 * da Java) l'attributo valCampo (gi� presente sotto id.valCampo) in modo da
 * renderlo compatibile con le CoolSelect.
 * 
 * TODO Per il momento questa funzione fa side effects sull'oggetto originale
 *      passato in ingresso. In futuro sarebbe comodo gestire la modifica
 *      con meccanismi di immutabilit�.
 * 
 * @param {*} apDom 
 */


Utils.prototype.updateDomForSelect = function (apDom) {
  if (apDom) {
    apDom.forEach(function (item) {
      item.valCampo = item.id.valCampo;
    });
  }

  return apDom;
};
/**
 * 
 * @param {*} fieldPath 
 * @param {*} item 
 * @param {*} value 
 */


Utils.prototype.setVal = function (fieldPath, item, value) {
  if (item === undefined || item === null || fieldPath === undefined || fieldPath === null) return null; // use path to set value

  var idx = ("" + fieldPath).indexOf('.');
  if (idx === -1) item[fieldPath] = value;else {
    var pp = fieldPath.split('.');
    var o = item;

    for (var i = 0; i < pp.length - 1; i++) {
      o = o[pp[i]];

      if (o === null || o === undefined) {
        o = {};
        break;
      }
    }

    o[pp[pp.length - 1]] = value;
  }
};

var Utils$1 = new Utils();

/**
 * @class
 * @classdesc TreeFlatten <br/>
 * This Object is treated as a class so the usage would be 'new common.TreeFlatten()'
 * @constructor
 * @see aDataGrid
 * @see aDataGrid.useTree
 */

function TreeFlatten(treeField) {
  if (treeField === void 0) {
    treeField = 'children';
  }

  this.treeField = treeField;
}
/**
 * Crea una lista flat a partire da un tree sul campo indicato nel costruttore (se omesso, default 'children').
 * Per ogni riga in uscita aggiunge un sotto-oggetto _tree con le informazioni necessarie 
 * SENZA creare il sotto-campo (property) .level.
 * 
 * @param {*} treeObject l'oggetto tree di partenza
 * @param {*} objidFunc funzione per calcolare su un oggetto un id univoco (non required)
 * @returns array delle righe compatibile con la modalità tree di aDataGrid
 */


TreeFlatten.prototype.flattenTree = function (treeObject, objidFunc) {
  return this._flatten(lodash.cloneDeep(treeObject), 0, objidFunc, undefined, true);
};
/**
 * Crea una lista flat a partire da un tree sul campo indicato nel costruttore (se omesso, default 'children').
 * Per ogni riga in uscita aggiunge un sotto-oggetto _tree con le informazioni necessarie 
 * creando anche la property .level legata al ._tree.level, per retrocompatibilità.
 * 
 * @param {*} treeObject l'oggetto tree di partenza
 * @param {*} lev livello di partenza (non usato, esiste per retrocompatibilità)
 * @param {*} objidFunc funzione per calcolare su un oggetto un id univoco (non required)
 */


TreeFlatten.prototype.flatten = function (treeObject, lev, objidFunc) {
  return this._flatten(lodash.cloneDeep(treeObject), 0, objidFunc, undefined, false);
};
/**
 * Elimina le inforamzioni di tree dalla lista (precedentemente creata con i metodi flatten()/flattenTree()) 
 * e restituendo un albero costruito sulla base del campo passato nel costruttore (default 'children')
 * 
 * @param {*} list 
 * @returns {*} oggetto tree
 */


TreeFlatten.prototype.unflatten = function (list) {
  if (!list) return null;
  list = lodash.cloneDeep(list);
  var tree = list[0];

  if (!tree || tree._tree === undefined || tree._tree.level !== 0) {
    console.error("non convertibile in tree, il primo elemento deve essree quello di livello 0");
    return null;
  }

  tree = this._removeTreeFields(tree, false);

  this._unflatten(list, tree, 1, 1, false);

  return tree;
};
/**
 * Elimina le inforamzioni di tree dalla lista (precedentemente creata con i metodi flatten()/flattenTree()) 
 * e restituendo un albero costruito sulla base del campo passato nel costruttore (default 'children')
 * SENZA considereare il campo .level ()
 * @param {*} list 
 * @returns {*} oggetto tree
 */


TreeFlatten.prototype.unflattenTree = function (list) {
  if (!list) return null;
  list = lodash.cloneDeep(list);
  var tree = list[0];

  if (!tree || tree._tree === undefined || tree._tree.level !== 0) {
    console.error("non convertibile in tree, il primo elemento deve essree quello di livello 0");
    return null;
  }

  tree = this._removeTreeFields(tree, true);

  this._unflatten(list, tree, 1, 1, true);

  return tree;
}; // ==== PRIVATE METHODS =====


TreeFlatten.prototype._flatten = function (treeObject, level, objidFunc, parentId, noLevelProp) {
  var _this = this;

  var list = [];
  if (!level) level = 0;
  if (!treeObject) return [];

  if (level === 0 && treeObject._tree) {
    treeObject = this._removeTreeFields(treeObject, noLevelProp);
  }

  var nextLevel = level + 1;
  if (!objidFunc) objidFunc = this._calcId;

  if (!parentId) {
    parentId = null;
  }

  if (treeObject.constructor === Array) {
    treeObject.map(function (item, idx) {
      var el = _this._updateTreeLevel(item, level, parentId, objidFunc, list.length, noLevelProp);

      list.push(el);

      var sub = _this._flatten(item[_this.treeField], nextLevel, objidFunc, el._tree.id, noLevelProp);

      el._tree.hasknot = sub && sub.length > 0;
      list = list.concat(sub);
    });
  } else {
    var el = this._updateTreeLevel(treeObject, level, parentId, objidFunc, list.length, noLevelProp);

    list.push(el);

    var sub = this._flatten(treeObject[this.treeField], nextLevel, objidFunc, el._tree.id, noLevelProp);

    el._tree.hasknot = sub && sub.length > 0;
    list = list.concat(sub);
  }

  return list;
};

TreeFlatten.prototype._calcId = function (obj, idx) {
  //return "_idx__" + idx;
  return Utils$1.guid();
};

TreeFlatten.prototype._updateTreeLevel = function (obj, level, parentId, objidFunc, index, noLevelProp) {
  var idx = index !== undefined ? index : 0;
  if (!objidFunc) objidFunc = this._calcId;
  var id = Utils$1.toId(objidFunc(obj, idx));

  if (obj._tree !== undefined) ;

  obj._tree = {
    level: level,
    id: id,
    parentId: parentId,
    hasknot: false
  };

  if (!noLevelProp) {
    if (obj.level !== undefined) {
      //console.warn("object ", obj, " already has a .level field/property - OVERWRITE");
      //obj.level = undefined;
      // delete obj.level;
      if (Object.isFrozen(obj)) {
        obj = Object.unfreeze(obj);
      }

      delete obj.level; //Object.undefineProperty
    }

    Object.defineProperty(obj, 'level', {
      configurable: true,
      get: function get() {
        //console.warn("TreeFlatten - UTILIZZO OBSOLETO del campo .level diretto invece del _tree.level")
        return this._tree ? this._tree.level : undefined;
      }
    });
  }

  return obj;
};

TreeFlatten.prototype._removeTreeFields = function (obj, noLevelProp) {
  if (!obj) return null;

  if (Object.isFrozen(obj)) {
    obj = Object.unfreeze(obj);
  } //obj._tree = undefined;


  if (obj._tree !== undefined) {
    // obj._tree = undefined;
    delete obj._tree;
  }

  if (!noLevelProp && obj.level !== undefined) {
    // obj.level = undefined;
    delete obj.level;
  }

  return obj;
};

TreeFlatten.prototype._unflatten = function (list, tree, childrenLevel, startFromIndex, noLevelProp) {
  if (!tree) return startFromIndex;
  var children = [];
  var nextLevel = childrenLevel + 1;
  var lastOk = startFromIndex;
  var prevItem = null;

  for (var i = startFromIndex; i < list.length; i++) {
    var item = list[i];

    if (!item._tree) {
      //console.warn("item", item, " senza campo ._tree");
      continue;
    }

    if (item._tree.level < childrenLevel) {
      break;
    } else if (item._tree.level === childrenLevel) {
      item = this._removeTreeFields(item, noLevelProp);
      children.push(item);
      prevItem = item;
      lastOk = i;
    } else if (item._tree.level === nextLevel) {
      i = this._unflatten(list, prevItem, nextLevel, i, noLevelProp);
    }
  }

  tree[this.treeField] = children;
  return lastOk;
};

/**
 * @class
 * @classdesc This class is only used for repeating a function to itself.
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.Debouncer.[methodName]
 * @constructor
 */
function Debouncer() {
  this.handler = {};
}
/**
 * Rebounce the function passed in the parameters to recall itself after a certain amount of time.
 * @param {String} id The id connected to the function passed
 * @param {Number} timems The time in milliseconds that the function should wait to debounce
 * @param {Function} func The function witch is wished to debounce
 * @param  {...any} params Any parameters that function needs to be passed by
 */


Debouncer.prototype.debounce = function (id, timems, func) {
  for (var _len = arguments.length, params = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    params[_key - 3] = arguments[_key];
  }

  this.clear(id);
  this.handler[id] = setTimeout(function () {
    func.apply(void 0, params);
  }, timems || 600);
};
/**
 * Stops the debounce of the function connected with the passed id
 * @param {String} id The id for the function wich is intended to be stopped
 */


Debouncer.prototype.clear = function (id) {
  var hand = this.handler[id];

  if (hand) {
    clearTimeout(hand);
    this.handler[id] = null;
  }
};

var exp$2 = new Debouncer();

/**
 * @class
 * @classdesc Classe per tutte le funzionalita estensive di calcolazione.<br/>
 * Per Evitare problemi di calcoli usare questa classe per tutti i calcoli.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.ArmDecimal.[methodName]
 * @constructor
 */

function ArmDecimal() {}
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} The sum of the two numbers
 */


ArmDecimal.prototype.add = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = Decimal__default["default"].add(int1, int2);
  return ret.toNumber();
};
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} The subtraction of the two numbers
 */


ArmDecimal.prototype.sub = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = Decimal__default["default"].sub(int1, int2);
  return ret.toNumber();
};
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} Division of the two numbers passed
 */


ArmDecimal.prototype.div = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = Decimal__default["default"].div(int1, int2);
  return ret.toNumber();
};
/**
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} Multiplication of the two numbers
 */


ArmDecimal.prototype.mul = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var ret = Decimal__default["default"].mul(int1, int2);
  return ret.toNumber();
};
/**
 * For all the roundings are made with ROUND_HALF_UP mode
 * @param {Number} int The number in input
 * @param {Number} scale The scale that should be considered for the rounding
 * @returns {Number} The value of the rounded number based on the scale Ritorna il valore del numero arrotondato in base al 'roundingInteger'
 */


ArmDecimal.prototype.round = function (_int, scale) {
  if (!_int) {
    _int = 0;
  }

  var decimal = new Decimal__default["default"](_int);
  var ret = decimal.toDecimalPlaces(scale, Decimal__default["default"].ROUND_HALF_UP);
  return ret.toNumber();
};
/**
 * Fa il compare dei due numeri 
 * @param {Number} int1 first number in the equation
 * @param {Number} int2 second number in the equation
 * @returns {Number} Se il resultato e' :<br/>
 *      1) res < 0 allora int1 < int2;<br/>
 *      2) res = 0 allora int1 = int2;<br/>
 *      3) res > 0 allora int1 > int2;
 */


ArmDecimal.prototype.compare = function (int1, int2) {
  if (!int1) {
    int1 = 0;
  }

  if (!int2) {
    int2 = 0;
  }

  var decimal1 = new Decimal__default["default"](int1);
  var decimal2 = new Decimal__default["default"](int2);
  var ret = decimal1.comparedTo(decimal2);
  return ret;
};

var exp$1 = new ArmDecimal();

/**
 * @class
 * @classdesc Class with all possible validations needed.<br/>
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.FieldValidation.[methodName]
 * @constructor
 */
function FieldValidation() {}
/**
 * Verify if the passed value is as an email adress format. The control is done with regex.
 * @param {String} value The mail to be checked
 * @returns {String} If the mail is not valid the 'formato email non valido' is returned othervise '' is returned
 */


FieldValidation.prototype.isEmail = function (value) {
  if (value === '') {
    return "";
  }

  var rex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;

  if (rex.test(value)) {
    return "";
  }

  return "formato email non valido";
};

var exp = new FieldValidation();

/**
 * @class
 * @classdesc return information about system and web browser, and so on... typically global static information.
 * 
 * ATTENTION! This is a SINGLETON CLASS so it should be accessed as common.ArmInfo.[methodName]
 * @constructor
 */
function ArmInfo() {
  // prepare all infos
  this.info = {
    flexGapSupported: null,
    gridGapSupported: null,
    dev: true
  };
  this.info.supportTouch = "ontouchstart" in document.documentElement || false; // https://stackoverflow.com/questions/46101264/detect-firefox-support-for-screen-sharing

  this.info.supportScreenSharing = navigator.mediaDevices && "getDisplayMedia" in navigator.mediaDevices || false;
  this.info.dev = window.ARM_IS_DEV || process.env.NODE_ENV !== "production";
}
/**
 * @returns true if web application is running in development mode.
 */


ArmInfo.prototype.isDev = function () {
  return this.info.dev;
};
/**
 * @returns true if the device supports touch events.
 */


ArmInfo.prototype.supportTouch = function () {
  return this.info.supportTouch;
};
/**
 * @returns true if the device supports flex gap property.
 */


ArmInfo.prototype.supportFlexGap = function () {
  if (this.info.flexGapSupported !== null) {
    return this.info.flexGapSupported;
  } // create flex container with row-gap set


  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px"; // create two, elements inside it

  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div")); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap

  flex.parentNode.removeChild(flex);
  this.info.flexGapSupported = isSupported;
  return isSupported;
};
/**
 * @returns true if the device supports grid gap property.
 */


ArmInfo.prototype.supportGridGap = function () {
  if (this.info.gridGapSupported !== null) {
    return this.info.gridGapSupported;
  } // create grid container with row-gap set


  var grid = document.createElement("div");
  grid.style.display = "grid";
  grid.style.rowGap = "1px"; // create two, elements inside it

  grid.appendChild(document.createElement("div"));
  grid.appendChild(document.createElement("div")); // append to the DOM (needed to obtain scrollHeight)

  document.body.appendChild(grid);
  var isSupported = grid.scrollHeight === 1; // grid container should be 1px high from the row-gap

  grid.parentNode.removeChild(grid);
  this.info.gridGapSupported = isSupported;
  return isSupported;
};
/**
 * @returns true if the device supports screen sharing
 */


ArmInfo.prototype.supportScreenSharing = function () {
  return this.info.supportScreenSharing;
};

var ArmInfo$1 = new ArmInfo();

var common = {
  version: pkg.version,
  WebRest: WebRest,
  Utils: Utils$1,
  DateFormatter: exp$4,
  ArmDecimal: exp$1,
  NumberFormatter: NumberFormatter$1,
  Debouncer: exp$2,
  FieldValidation: exp,
  UiUtils: exp$3,
  TreeFlatten: TreeFlatten,
  ArmInfo: ArmInfo$1,
  config: config
};

exports.ArmDecimal = exp$1;
exports.ArmInfo = ArmInfo$1;
exports.DateFormatter = exp$4;
exports.Debouncer = exp$2;
exports.FieldValidation = exp;
exports.NumberFormatter = NumberFormatter$1;
exports.TreeFlatten = TreeFlatten;
exports.UiUtils = exp$3;
exports.Utils = Utils$1;
exports.WebRest = WebRest;
exports.armundiaInit = armundiaInit;
exports.config = config;
exports["default"] = common;
exports.domain = domain;
exports.domainInfoVal = domainInfoVal;
exports.domainVal = domainVal;
exports.getLocale = getLocale;
exports.i18n = i18n;
exports.isAuth = isAuth;
exports.mapInfoVal = mapInfoVal;
exports.opt = opt;
exports.setLocale = setLocale;
exports.stringInfoVal = stringInfoVal;
//# sourceMappingURL=index.js.map
